"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiMapError = exports.runPromisesSequentially = exports.multiMap = void 0;
const times_1 = __importDefault(require("lodash/times"));
const fsm_data_1 = require("./fsm-data");
const multiMap = async (data, threadCount, mapFn) => {
    const dataArray = data.map((x, i) => ({
        index: i,
        inputValue: x,
        started: false,
        err: undefined,
        promise: undefined,
        outputValue: undefined,
    }));
    await Promise.all((0, times_1.default)(threadCount, async (threadID) => {
        await (0, exports.runPromisesSequentially)(dataArray.map(item => async () => {
            if (item.started) {
                return;
            }
            item.started = true;
            item.promise = mapFn(item.inputValue, item.index, threadID);
            await item.promise
                .then(v => {
                item.outputValue = v;
            })
                .catch(err => {
                item.err = err instanceof Error ? err.message : 'Unknown';
                console.error(item.err);
            });
        }));
    }));
    const items = (0, fsm_data_1.fsmData)(dataArray, {
        sort: x => x.index,
        map: x => ({
            index: x.index,
            input: x.inputValue,
            output: x.outputValue,
            err: x.err,
        }),
    });
    const response = {
        completed: dataArray.filter(x => !x.err).length,
        failed: dataArray.filter(x => x.err).length,
        items: items,
        output: items.map(x => x.output),
    };
    if (response.items.filter(x => x.err).length > 0) {
        throw new MultiMapError(response);
    }
    return response;
};
exports.multiMap = multiMap;
const runPromisesSequentially = async (fns) => {
    const runNext = async (index, results) => {
        const fn = fns[index];
        return fn ? runNext(index + 1, [...results, await fn()]) : results;
    };
    return runNext(0, []);
};
exports.runPromisesSequentially = runPromisesSequentially;
class MultiMapError extends Error {
    items;
    constructor(items) {
        super('Errors processing multi-map');
        this.items = items;
        this.items = items;
    }
}
exports.MultiMapError = MultiMapError;
//# sourceMappingURL=multi-map.js.map